import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import Button from 'components/button/button';
import Link from 'components/link';
import { isPresent } from '@seedlang/utils';
import eventParamsHelper from 'utils/event_params_helper';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  z-index: 1;
  border-radius: 20px;
  margin: 80px 20px 20px;
  max-width: 500px;
  background: #FFF;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 5px solid #CCC;
  p {
    text-decoration: center;
  }

`;

const ButtonRow = styled.div`
  margin-top: 20px;
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 0;
`;

@observer
class UnpublishedMemrevHome extends React.Component {

  componentDidMount() {
    // If the param allowUnpublishedAccess query param is present, set the cookie, so that the user can access the site
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get('allowUnpublishedAccess');
    AppUI.setCookieValue('allowUnpublishedAccess', value);
  }
  onClickBecomeMember = () => {
    AppUI.createEvent('memrev - click become a member button', eventParamsHelper({
      source: 'unpublished_home',
      button_text: 'Become a Member',
      source_route: AppUI.routeStore.routeName,
      source_path: window.location.pathname,
      destination_url: AppUI.site.patreonMembershipPage,
    }));
    window.open(AppUI.site.patreonMembershipPage, '_blank', 'noopener,noreferrer');
  }

  render() {
    return (
      <Wrapper>
        <Container>
          <p>This website is currently under construction and will be live very soon.</p>
          {
            isPresent(AppUI.site.patreonMembershipPage) &&
              <p>If you're looking to become a member of {AppUI.site.teamName}, please check out our current Membership offers on Patreon.</p>
          }
          <ButtonRow>
            {
              isPresent(AppUI.site.patreonMembershipPage) &&
                <Button
                  margin='0 0 10px 0'
                  width='100%'
                  onClick={this.onClickBecomeMember}
                  background={AppUI.site.accentColor}
                >
                  Become a Member
                </Button>
            }
            <Link
              to='onboarding.sign_in'
              style={{width: '100%'}}
            >
              <Button
                margin='0'
                width='100%'
                background={AppUI.site.accentColor}
              >
                Early Access Sign-In
              </Button>
            </Link>
          </ButtonRow>
        </Container>
      </Wrapper>
    );
  }
}

export default UnpublishedMemrevHome;
